"use strict";
"use client";
import { Clipboard } from '@ark-ui/react/clipboard';
import { createSlotRecipeContext } from '../../styled-system/create-slot-recipe-context.js';

const {
  withProvider,
  withContext,
  useStyles: useClipboardStyles,
  PropsProvider
} = createSlotRecipeContext({ key: "clipboard" });
const ClipboardRootProvider = withProvider(Clipboard.RootProvider, "root", { forwardAsChild: true });
const ClipboardRoot = withProvider(
  Clipboard.Root,
  "root",
  { forwardAsChild: true }
);
const ClipboardPropsProvider = PropsProvider;
const ClipboardTrigger = withContext(Clipboard.Trigger, "trigger", { forwardAsChild: true });
const ClipboardControl = withContext(Clipboard.Control, "control", { forwardAsChild: true });
const ClipboardIndicator = withContext(Clipboard.Indicator, "indicator", { forwardAsChild: true });
const ClipboardInput = withContext(Clipboard.Input, "input", { forwardAsChild: true });
const ClipboardLabel = withContext(Clipboard.Label, "label", { forwardAsChild: true });
const ClipboardContext = Clipboard.Context;

export { ClipboardContext, ClipboardControl, ClipboardIndicator, ClipboardInput, ClipboardLabel, ClipboardPropsProvider, ClipboardRoot, ClipboardRootProvider, ClipboardTrigger, useClipboardStyles };
